<script setup lang="ts">
/**
 * Multiple choice: the options and which one is right. The key is the option's id (decision 8), so
 * reordering never moves it; the player shuffles. One correct option — marking another moves it.
 */
import type { InputPrimaryEvent } from '@shared/ui/fields'
import type { MathExerciseEditorProps } from '../../../../../model/assignments/math-exercise-editors.hook'

import { BtnCheckbox } from '@shared/ui/buttons'
import { InputPrimary } from '@shared/ui/fields'

import { useMathExerciseAnswerKey } from '../../../../../model/assignments/math-exercise-editors.hook'
import { MATH_CHOICE_MIN_OPTIONS } from '../../../../../lib/assignments/math-practice-schema'
import ExerciseItemList from '../ExerciseItemList.vue'

defineOptions({
  name: 'ExerciseMultipleChoice',
})

const props = defineProps<MathExerciseEditorProps>()

const {
  refCorrectId,
  setCorrectId,
} = useMathExerciseAnswerKey(() => props.exercise)
</script>

<template>
  <ExerciseItemList
    :exercise="exercise"
    list="options"
    noun="option"
    label="Options"
    :min="MATH_CHOICE_MIN_OPTIONS"
  >
    <template #item="{ row, update }">
      <BtnCheckbox
        text="Correct"
        class="exercise-multiple-choice__correct"
        :checked="row.id === refCorrectId"
        @click="setCorrectId(row.id)"
      />
      <InputPrimary
        name="option-text"
        class-name="exercise-multiple-choice__text"
        :value="row.values.text"
        placeholder="What the kid can choose — $…$ for math"
        @input="(event: InputPrimaryEvent) => update({ text: String(event.value) })"
      />
    </template>
  </ExerciseItemList>
</template>

<style scoped lang="scss" src="./ExerciseMultipleChoice.scss" />
